import { User, Mail, ShieldCheck, Award } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ROLE_LABEL = { admin: "Organização", moderator: "Moderador(a) de chat", participant: "Participante" };

export default function Profile() {
  const { user } = useAuth();
  if (!user) return null;

  const rows = [
    { icon: User, label: "Nome", value: user.name || "—" },
    { icon: Mail, label: "E-mail da inscrição", value: user.email },
    { icon: ShieldCheck, label: "Tipo de acesso", value: ROLE_LABEL[user.role] || user.role },
    { icon: Award, label: "Certificado", value: user.certificate_released ? "Liberado" : "Aguardando liberação" },
  ];

  return (
    <div className="max-w-2xl mx-auto" data-testid="profile-page">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white mb-6">Meu Perfil</h1>
      <div className="card-room space-y-4">
        {rows.map(({ icon: Icon, label, value }) => (
          <div key={label} className="flex items-center gap-4 bg-[#0C1530]/60 border border-[#00C8FF]/15 rounded-lg px-4 py-3.5">
            <Icon size={18} className="text-[#00C8FF] shrink-0" />
            <div className="min-w-0">
              <p className="text-xs font-data tracking-wider uppercase text-slate-500">{label}</p>
              <p className="text-sm text-white font-medium truncate" data-testid={`profile-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}>{value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
